<template>
    <div><b-icon icon="envelope"/> {{ data.msg }}</div>
</template>

<script>
export default {
    name:"TravellerMsg",
    props: {
        data: null
    }
}
</script>